import { EASING_FUNCTIONS } from '@/scripts/helpers/constants/easingFunctions';

function smoothScrollTo({
  top,
  left,
  duration = 0,
  element = document.scrollingElement,
  easingFunction = EASING_FUNCTIONS.slowInSlowOut
}) {
  const startTop = element.scrollTop, startLeft = element.scrollLeft;
  top ??= startTop;
  left ??= startLeft;
  top = Math.max(0, Math.min(element.scrollHeight - element.clientHeight, top));
  left = Math.max(0, Math.min(element.scrollWidth - element.clientWidth, left));
  if (startTop === top && startLeft === left) return;
  const distanceTop = top - startTop, distanceLeft = left - startLeft;

  let x = 0, prevTimestamp = null;

  function step (newTimestamp) {
    x += (newTimestamp - prevTimestamp) / duration;
    x = Math.min(x, 1);
    const fraction = easingFunction(x);
    element.scroll({
      top: startTop + fraction * distanceTop,
      left: startLeft + fraction * distanceLeft,
      behavior: 'instant'
    });
    if (x >= 1) return;
    prevTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame((timestamp) => {
    prevTimestamp = timestamp;
    window.requestAnimationFrame(step);
  });
}

export function smoothScrollToTop({ duration, easingFunction } = {}) {
  smoothScrollTo({
    top: 0,
    duration: duration,
    easingFunction: easingFunction
  });
}
